import {Space} from 'antd';
import styled from 'styled-components';
import {bordersStyles} from '../../../../../utils/styles';

const StyledTagsManagement = styled(Space)`
  ${bordersStyles.default};
  background-color: ${props => props.theme.colors.neutral_1};
  padding: 24px;
`;

const StyledTagsManagementSpace = styled(Space)`
  align-items: stretch;
  & > .ant-space-item {
    display: flex;
    width: calc(50% - 12px);

    & > * {
      width: 100%;
    }
  }
`;

export {
  StyledTagsManagement,
  StyledTagsManagementSpace
}
